
import { qualityService } from "@/service";
import { useStore } from "@/store";
import { defineComponent, reactive, ref, computed } from "vue";
interface PageData {
  list: Array<any>;
  loading: boolean;
  finished: boolean;
  page: number;
}
export default defineComponent({
  setup() {
    const endTabList = [
      { value: "2,3", label: "全部" },
      { value: "2", label: "整改完成" },
      { value: "3", label: "未整改" }
    ];
    const vantActive = ref(0);
    const endTabActive = ref("2,3");
    const searchName = ref("");
    const pageList = ref([]);
    const pageData = reactive<PageData>({
      list: [],
      loading: false,
      finished: false,
      page: 1
    });
    const store = useStore();
    const userInfo = computed(() => store.state.userInfo);
    const onLoad = async () => {
      try {
        const states = vantActive.value === 0 ? "1" : endTabActive.value;
        const { data } = await qualityService.reform_lists({
          liable_user_id: userInfo.value?.id,
          states,
          search_name: searchName.value,
          page: pageData.page
        });
        pageData.list.push(...data.data);
        pageData.loading = false;
        pageData.finished = false;
        pageData.page++;
        if (pageData.list.length >= data.total) {
          pageData.finished = true;
        }
      } catch (error) {
        pageData.list = [];
        pageData.finished = true;
      }
    };

    const onSearch = () => {
      pageData.list = [];
      pageData.page = 1;
      onLoad();
    };

    const onChange = () => {
      pageData.list = [];
      pageData.page = 1;
      onLoad();
    };

    onLoad();

    const onClickTab = () => {
      pageData.list = [];
      pageData.page = 1;
      endTabActive.value = "2,3";
      onLoad();
    };

    const clickEndTab = (value: string) => {
      endTabActive.value = value;
      onChange();
    };

    return {
      pageList,
      pageData,
      onLoad,
      onSearch,
      onChange,

      vantActive,
      searchName,
      onClickTab,
      endTabList,
      endTabActive,
      clickEndTab
    };
  }
});
